import { updateCustomerDetails, getCustomerAccessToken } from 'libs/helpers/customer'

class CustomForm extends HTMLElement {
  constructor() {
    super()
    this.isValid = this.validFormKey()
    this.ignoreAttributes = this.ignoreAttributes()
  }

  connectedCallback() {
    const form = this.querySelector('form')
    if (!this.isValid) {
      form.innerHTML = 'Invalid form key'
      return
    }

    form.addEventListener('submit', async (e) => {
      await this.onSubmit(e)
    })
  }

  async onSubmit(e) {
    try {
      const key = this.callbackKey()
      const callback = this.formActionKeys(key)
      await callback(e)
    } catch (err) {
      console.log(err)
    }
  }

  /**
   * Callback key to be used in the form action
   * @returns
   */
  callbackKey() {
    return this.dataset.action
  }

  /** Keys to ignore when parse customer data into JSON object. */
  ignoreAttributes() {
    const ignore = this.dataset.ignore
    if (!ignore) return {}
    return JSON.parse(ignore)
  }

  /** TODO: Might be needed post launch */
  async passwordReset(e) {}

  /** TODO: Might be needed post launch */
  async passwordRecover(e) {}

  /**
   * Sadly shopify does not offer an native form for updating customer details.
   *
   * Using the storefront Api to update customer details
   * @param {*} e
   */
  async updateDetails(e) {
    e.preventDefault()
    const emailRef = this.dataset.emailRef
    const { json, formData } = this.parseFormData(e, this.ignoreAttributes)
    const customerAccessToken = await getCustomerAccessToken(json.email, formData.get('password').toString())
    await updateCustomerDetails(customerAccessToken, json, emailRef)
  }

  /**
   *
   * Parse the FormData into a JSON object
   * returns both form data and json object.
   *
   * Optional ignore keys which wont be parsed into the object.
   *
   * @param {*} e
   * @param {*} ignoreKeys
   */
  parseFormData(e, ignoreKeys = {}) {
    const formData = new FormData(e.target)
    const data = {}
    formData.forEach((value, key) => {
      if (!value.length || ignoreKeys[key]) return
      data[this.snakeToCamel(key)] = value
    })
    return {
      json: data,
      formData
    }
  }

  /**
   *
   * @param {*} str
   * @returns
   */
  snakeToCamel(str) {
    return str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
  }

  /**
   *
   * @param {*} key
   * @returns
   */
  formActionKeys(key) {
    return {
      'password-reset': this.passwordReset.bind(this),
      'password-recover': this.passwordRecover.bind(this),
      'update-details': this.updateDetails.bind(this)
    }[key]
  }

  /**
   * Checks if the callback key is valid
   * @returns boolean
   */
  validFormKey() {
    return !!this.formActionKeys(this.callbackKey())
  }
}

window.customElements.define('x-custom-form', CustomForm)
